(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ge-closer-look"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!input.classList || !input.classList.contains('ge-compare__range')) return;
    var root = input.closest('.ge-compare');
    if (root) root.style.setProperty('--ge-split', input.value + '%');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ge-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // A <picture><source> outranks the img's own src, so every swap has to clear
    // it too or the phone keeps showing the previous image. Defined out here so
    // both the variant sync and the thumbnail click handler can reach it.
    function geSetHeroImage(imgEl, url) {
      var srcEl = imgEl.parentElement && imgEl.parentElement.querySelector('source');
      if (!srcEl) return;
      if (!srcEl.dataset.geDefaultSrcset) {
        srcEl.dataset.geDefaultSrcset = srcEl.getAttribute('srcset') || '';
      }
      if (url) {
        srcEl.setAttribute('srcset', url);
      } else if (srcEl.dataset.geDefaultSrcset) {
        srcEl.setAttribute('srcset', srcEl.dataset.geDefaultSrcset);
      }
    }

    function sync(root) {
      var dataEl = root.querySelector('[data-ge-variants]');
      var idInput = root.querySelector('[data-ge-variant-id]');
      if (!dataEl || !idInput) return;

      var variants;
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      var chosen = [];
      root.querySelectorAll('.ge-hero__radio:checked').forEach(function (input) {
        chosen[parseInt(input.dataset.optionPosition, 10) - 1] = input.value;
      });

      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return chosen[i] === undefined || chosen[i] === opt;
        });
      });

      var priceEl = root.querySelector('[data-ge-price]');
      var submit = root.querySelector('[data-ge-submit]');

      if (match) {
        idInput.value = match.id;
        if (priceEl) priceEl.textContent = match.priceFormatted;
        if (submit) {
          submit.disabled = !match.available;
          submit.textContent = !match.available
            ? 'Sold out'
            : match.preorder ? submit.dataset.preLabel || 'Pre-order' : submit.dataset.label || 'Add to cart';
        }
        root.querySelectorAll('[data-ge-preorder]').forEach(function (input) {
          input.disabled = !match.preorder;
          input.value = match.preorder || '';
        });
      }

      // sticky bar tracks the same variant
      var sPrice = root.querySelector('[data-ge-sticky-price]');
      var sId = root.querySelector('[data-ge-sticky-id]');
      var sBtn2 = root.querySelector('[data-ge-sticky-submit]');
      if (match) {
        if (sPrice) sPrice.textContent = match.priceFormatted;
        if (sId) sId.value = match.id;
        if (sBtn2) {
          sBtn2.disabled = !match.available;
          sBtn2.textContent = !match.available
            ? 'Sold out'
            : match.preorder ? sBtn2.dataset.preLabel || 'Pre-order' : sBtn2.dataset.label || 'Add to cart';
        }
      }

      // featured image follows the chosen options
      var imgEl = root.querySelector('.ge-hero__img');
      var mapEl = root.querySelector('[data-ge-variant-images]');
      if (imgEl && mapEl) {
        if (!imgEl.dataset.geDefault) {
          imgEl.dataset.geDefault = imgEl.getAttribute('src') || '';
          imgEl.dataset.geDefaultSrcset = imgEl.getAttribute('srcset') || '';
        }
        var slug = function (v) {
          return String(v).toLowerCase()
            .replace(/[\u2122\u00ae]/g, '')
            .replace(/\s*\(pre-order\)/, '')
            .replace('nylon sheathing', 'nylon')
            .replace('osprey hydraulics', 'osprey')
            .trim()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
        };
        var key = [slug(chosen[0] || ''), slug(chosen[1] || ''), slug(chosen[2] || '')].join('|');
        var images = {};
        try { images = JSON.parse(mapEl.textContent); } catch (e) {}
        var url = images[key];
        if (url) {
          imgEl.removeAttribute('srcset');
          geSetHeroImage(imgEl, url);
          imgEl.src = url;
        } else if (imgEl.dataset.geDefault) {
          imgEl.src = imgEl.dataset.geDefault;
          geSetHeroImage(imgEl, null);
          if (imgEl.dataset.geDefaultSrcset) imgEl.setAttribute('srcset', imgEl.dataset.geDefaultSrcset);
        }
      }

      root.querySelectorAll('.ge-hero__option').forEach(function (field) {
        var picked = field.querySelector('.ge-hero__radio:checked');
        var out = field.querySelector('[data-ge-optvalue]');
        if (!picked || !out) return;
        var d = picked.dataset.delta;
        out.textContent = d ? picked.value + ' ' + d : picked.value;
      });

      root.querySelectorAll('[data-ge-note]').forEach(function (note) {
        note.hidden = chosen.indexOf(note.dataset.trigger) === -1;
      });
    }

    function init(root) {
      var submit = root.querySelector('[data-ge-submit]');
      if (submit && !submit.dataset.label) submit.dataset.label = submit.textContent.trim();
      if (submit && !submit.dataset.preLabel) submit.dataset.preLabel = submit.getAttribute('data-ge-pre-label') || 'Pre-order';
      var sBtn = root.querySelector('[data-ge-sticky-submit]');
      if (sBtn && !sBtn.dataset.label) sBtn.dataset.label = sBtn.textContent.trim();
      if (sBtn && !sBtn.dataset.preLabel) sBtn.dataset.preLabel = sBtn.getAttribute('data-ge-pre-label') || 'Pre-order';
      sync(root);

      var bar = root.querySelector('[data-ge-sticky]');
      var actions = root.querySelector('.ge-hero__actions');
      if (!bar || !actions || typeof IntersectionObserver === 'undefined') return;
      if (bar.dataset.observed) return;
      bar.dataset.observed = '1';
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        });
      }, { rootMargin: '0px 0px -40% 0px' }).observe(actions);
    }

    document.addEventListener('click', function (event) {
      var thumb = event.target.closest('.ge-hero__thumb-btn');
      if (!thumb) return;
      var root = thumb.closest('.ge-hero');
      var main = root && root.querySelector('.ge-hero__img');
      if (!main) return;
      main.removeAttribute('srcset');
      geSetHeroImage(main, thumb.dataset.geThumb);
      main.src = thumb.dataset.geThumb;
      root.querySelectorAll('.ge-hero__thumb-btn').forEach(function (b) {
        b.classList.toggle('is-active', b === thumb);
        if (b === thumb) { b.setAttribute('aria-current', 'true'); } else { b.removeAttribute('aria-current'); }
      });
    });

    // Waitlist dialog for coming-soon swatches.
    function openWaitlist(dialog, value) {
      if (!dialog || typeof dialog.show !== 'function') return;
      // out of the section so no transformed ancestor can trap position: fixed
      if (dialog.parentElement !== document.body) document.body.appendChild(dialog);
      if (value) {
        var nameEl = dialog.querySelector('[data-ge-waitlist-value]');
        var tagsEl = dialog.querySelector('[data-ge-waitlist-tags]');
        if (nameEl) nameEl.textContent = value;
        if (tagsEl) {
          var handle = value.toLowerCase().replace(/[™®]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
          tagsEl.value = 'waitlist, waitlist-' + handle;
        }
      }
      if (!dialog.open) {
        dialog.geOpener = document.activeElement;
        dialog.show();
      }
      var email = dialog.querySelector('input[type="email"]');
      if (email && email.offsetParent !== null) email.focus();
    }

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-ge-waitlist-open]');
      if (opener) {
        var root = opener.closest('.ge-hero');
        openWaitlist(document.getElementById(opener.getAttribute('aria-controls')), opener.dataset.geWaitlistOpen);
        return;
      }
      var dialog = event.target.closest('[data-ge-waitlist]');
      if (dialog) {
        if (event.target.closest('[data-ge-waitlist-close]')) closeWaitlist(dialog);
        return;
      }
      // a click on the dimmed page outside closes it
      document.querySelectorAll('[data-ge-waitlist][open]').forEach(closeWaitlist);
    });

    function closeWaitlist(dialog) {
      dialog.close();
      if (dialog.geOpener && dialog.geOpener.focus) dialog.geOpener.focus();
    }

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-ge-waitlist][open]').forEach(closeWaitlist);
    });

    document.addEventListener('change', function (event) {
      if (!event.target.classList.contains('ge-hero__radio')) return;
      var root = event.target.closest('.ge-hero');
      if (root) sync(root);
    });

    function boot() {
      document.querySelectorAll('.ge-hero').forEach(init);
      // The waitlist form posts natively (Shopify's hCaptcha only fills its
      // token on a real submit, so a fetch post is rejected with a 400). The
      // page reloads with the result rendered in the dialog; reopen it.
      document.querySelectorAll('[data-ge-waitlist]').forEach(function (dialog) {
        var shown = dialog.querySelector('[data-ge-waitlist-success]:not([hidden]), [data-ge-waitlist-error]:not([hidden])');
        if (shown) openWaitlist(dialog, null);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ge-press-kit"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-ge-copy]');
      if (!btn || !navigator.clipboard) return;
      var label = btn.querySelector('[data-ge-copy-label]');
      navigator.clipboard.writeText(btn.getAttribute('data-ge-copy')).then(function () {
        if (!label) return;
        label.textContent = 'Copied';
        setTimeout(function () { label.textContent = 'Copy'; }, 1500);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ge-stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var els = document.querySelectorAll('[data-ge-count]');
    if (!els.length) return;

    // Reduced motion, or no observer: the markup already holds the final value.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window) || !('requestAnimationFrame' in window)) return;

    function parse(text) {
      var m = text.match(/^(\D*)([\d.,]+)(.*)$/);
      if (!m) return null;
      var n = parseFloat(m[2].replace(/,/g, ''));
      if (isNaN(n)) return null;
      return { prefix: m[1], value: n, suffix: m[3], grouped: m[2].indexOf(',') > -1 };
    }

    function format(n, grouped) {
      var s = String(Math.round(n));
      return grouped ? s.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : s;
    }

    function run(el) {
      var p = parse(el.textContent.trim());
      if (!p) return;
      var duration = 1600;
      var started = null;
      function step(now) {
        if (started === null) started = now;
        var t = Math.min((now - started) / duration, 1);
        var eased = 1 - Math.pow(1 - t, 3);
        el.textContent = p.prefix + format(p.value * eased, p.grouped) + p.suffix;
        if (t < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          run(entry.target);
        });
      },
      { threshold: 0.4 }
    );

    els.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ge-testimonials"] && !Shopify.designMode) return;
  try {
    
  // The track does the scrolling; this only drives the buttons and keeps the
  // dots in step with wherever the reader has actually scrolled to.
  class GeQuotesCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ge-quotes__list');
      this.cards = Array.from(this.querySelectorAll('.ge-quotes__card'));
      this.dots = Array.from(this.querySelectorAll('.ge-quotes__dot'));
      this.arrows = Array.from(this.querySelectorAll('.ge-quotes__arrow'));
      if (!this.track || this.cards.length === 0) return;

      this.arrows.forEach((button) => {
        button.addEventListener('click', () => this.step(Number(button.dataset.dir)));
      });
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.scrollToIndex(Number(dot.dataset.index)));
      });

      this.sync = this.sync.bind(this);
      this.track.addEventListener('scroll', () => {
        window.clearTimeout(this.timer);
        this.timer = window.setTimeout(this.sync, 80);
      });
      window.addEventListener('resize', this.sync);
      this.sync();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.sync);
    }

    // How far one card sits from the next, gap included.
    get stride() {
      if (this.cards.length < 2) return this.track.clientWidth;
      return this.cards[1].offsetLeft - this.cards[0].offsetLeft;
    }

    get current() {
      return Math.round(this.track.scrollLeft / this.stride);
    }

    step(direction) {
      this.scrollToIndex(this.current + direction);
    }

    scrollToIndex(index) {
      const max = this.cards.length - 1;
      const target = Math.min(Math.max(index, 0), max);
      this.track.scrollTo({ left: this.cards[target].offsetLeft - this.cards[0].offsetLeft });
    }

    sync() {
      const index = this.current;
      this.dots.forEach((dot, i) => {
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      // Measured in cards rather than pixels, so a fractional resting position
      // after a snap does not read as "not at the start".
      const atStart = index <= 0;
      const atEnd = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 1;
      this.arrows.forEach((button) => {
        const forward = Number(button.dataset.dir) > 0;
        button.disabled = forward ? atEnd : atStart;
      });
    }
  }

  if (!customElements.get('ge-quotes-carousel')) {
    customElements.define('ge-quotes-carousel', GeQuotesCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ge-thanks-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var COLORS = ['#00a7ce', '#e87325', '#102f52', '#4fc3e8', '#ffffff'];

    function burst() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var layer = document.createElement('div');
      layer.className = 'ge-confetti';
      layer.setAttribute('aria-hidden', 'true');
      for (var i = 0; i < 90; i++) {
        var bit = document.createElement('span');
        var dur = 2.4 + Math.random() * 1.8;
        bit.style.left = Math.random() * 100 + 'vw';
        bit.style.background = COLORS[(Math.random() * COLORS.length) | 0];
        bit.style.setProperty('--ge-dx', (Math.random() * 240 - 120) + 'px');
        bit.style.setProperty('--ge-rot', (Math.random() * 1080 - 540) + 'deg');
        bit.style.animationDuration = dur + 's';
        bit.style.animationDelay = (Math.random() * 0.4) + 's';
        layer.appendChild(bit);
      }
      document.body.appendChild(layer);
      setTimeout(function () { layer.remove(); }, 5200);
    }

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-ge-confetti]')) burst();
    });

    // Fire once when the page opens, since this is the post-purchase landing.
    if (document.querySelector('[data-ge-confetti]')) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', burst);
      } else {
        burst();
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
